import { useMutation } from "@tanstack/react-query";
import { createBusinessClaimV2 } from "../../../apis";
import { CreateBusinessClaimParams } from "../../../apis/business";
import { Storage } from "common/storage";

/**
 * Posts the onboarding business claim.
 *
 * Separate from `usePostAddClaims` for the same reason `createBusinessClaimV2`
 * is separate from `addClaims` — and because this one has no venue-details
 * query to invalidate: the onboarding user isn't looking at a venue page.
 *
 * `mutateAsync` is returned alongside `mutate` so the caller can await the
 * result and only advance on success.
 */
export function usePostBusinessClaimV2() {
  const accessToken = Storage.getCurrentUserToken();

  const { mutate, mutateAsync, error, status, data, reset } = useMutation({
    mutationFn: (params: CreateBusinessClaimParams) =>
      createBusinessClaimV2(params, accessToken),
  });

  return { mutate, mutateAsync, error, status, data, reset };
}
